import { I18nService } from '@/core/services/i18nService';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-mail-confirmation',
  templateUrl: './mail-confirmation.component.html',
  styleUrls: ['./mail-confirmation.component.scss']
})
export class MailConfirmationComponent implements OnInit {

  email: string;
  message: string;

  constructor(protected route: ActivatedRoute, protected languageservice: I18nService) { }

  ngOnInit(): void {
    this.route.queryParams
      .subscribe(params => {
        this.email = params.email;

        if (params.from == 'pre-register')
          this.message = this.languageservice.instant("email-confirmation.pre-register");

        if (params.from == 'reset-password')
          this.message = this.languageservice.instant("email-confirmation.reset-password");
      }
    );
  }

}
